import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import type { SelectProps } from 'antd';
import { useDepartmentsForSelection } from '@/hooks/useDepartments';

export type DepartmentSelectProps = Omit<SelectProps, 'options' | 'mode'>;

/**
 * Finance departments master picker. Value is department_id (UUID).
 */
export const DepartmentSelect: React.FC<DepartmentSelectProps> = ({
  placeholder,
  allowClear = false,
  showSearch = true,
  ...rest
}) => {
  const { t } = useTranslation('common');
  const { data: departments = [], isLoading } = useDepartmentsForSelection();
  const resolvedPlaceholder = placeholder ?? t('selectDepartment');

  const options = useMemo(
    () =>
      departments.map((d) => ({
        value: d.id,
        label: `${d.department_code} - ${d.department_name}`,
      })),
    [departments]
  );

  return (
    <Select
      {...rest}
      allowClear={allowClear}
      showSearch={showSearch}
      loading={isLoading}
      placeholder={resolvedPlaceholder}
      options={options}
      optionFilterProp="label"
      filterOption={(input, option) =>
        String(option?.label ?? '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    />
  );
};
